/**
 * Sufixos numéricos usados no tagueamento legado (analytics.js) mapeados para
 * os IDs completos do SDK GTM (MARKETPLACE_TAG_IDS). O item "02" existe no
 * legado mas não está nomeado em MARKETPLACE_TAG_IDS — mantém-se o ID Tim.
 */
import { MARKETPLACE_TAG_IDS } from "./gtm";
const channel = process.env.REACT_APP_DEFAULT_CHANNEL;

const LEGACY_MENU_TAG = `${channel}.marketplace.02`;

export const tagIdFromLegacySuffix = (suffix) => {
  const map = {
    "01": MARKETPLACE_TAG_IDS.click,
    "02": LEGACY_MENU_TAG,
    "03": MARKETPLACE_TAG_IDS.clickList,
    "04": MARKETPLACE_TAG_IDS.clickFilter,
    "05": MARKETPLACE_TAG_IDS.clickFilterClose,
    "06": MARKETPLACE_TAG_IDS.clickMyAccount,
    "07": MARKETPLACE_TAG_IDS.clickAddressForm,
    "08": MARKETPLACE_TAG_IDS.clickCardForm,
    "09": MARKETPLACE_TAG_IDS.callback,
    "10": MARKETPLACE_TAG_IDS.clickMyRequests,
    "11": MARKETPLACE_TAG_IDS.clickPolicy,
    "12": MARKETPLACE_TAG_IDS.clickSearch,
    "13": MARKETPLACE_TAG_IDS.search,
    "14": MARKETPLACE_TAG_IDS.clickBuy,
    "15": MARKETPLACE_TAG_IDS.clickOrderResume,
    "16": MARKETPLACE_TAG_IDS.clickCheckoutAddresses,
    "17": MARKETPLACE_TAG_IDS.clickResumoCompra,
    "18": MARKETPLACE_TAG_IDS.clickOrderStatus,
    "19": MARKETPLACE_TAG_IDS.login,
  };
  return map[suffix] ?? MARKETPLACE_TAG_IDS.click;
};
